import React from "react"
import styled from "styled-components"
import { useFields } from "../App"

// @ts-ignore
const LicensePlateInput = styled.input`
    box-shadow: none !important;
    &::placeholder {
        color: rgba(0, 0, 0, 0.5);
    }
`

const Item = styled.div`
    &.is-selected {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
            var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
            calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
            var(--tw-shadow, 0 0 #0000);
    }
`

interface Props {
    options: {
        title: string
        icon?: {
            url: string
        }
    }[]
}

export default function StepOne({ options }: Props) {
    const fields = useFields()

    return (
        <div className="sm:mt-10">
            <h2 className="sm:text-2xl text-lg">Kenteken</h2>

            <div className="flex">
                <div className="bg-[#1762AB] flex flex-col items-center justify-between text-light w-[40px] h-[52px] py-1">
                    <img
                        className="w-[29px] h-[29px] mb-[1px]"
                        src={`${window.local_werkplaatsafspraak_object.asset}/license-stars.svg`}
                        alt=""
                    />
                    <span className="text-xs">NL</span>
                </div>

                <LicensePlateInput
                    onInput={(event) =>
                        fields.setLicensePlate(event.target.value.toUpperCase())
                    }
                    defaultValue={fields.licensePlate}
                    type="text"
                    className="bg-[#F9BF2A] w-[250px] flex flex-col justify-center items-center text-center text-xl tracking-widest border-none text-dark uppercase"
                    placeholder="XX-XXX-X"
                />
            </div>

            <div className="mt-3 text-[tomato]">
                {fields.licensePlate?.replaceAll("-", "").length > 6 && (
                    <p>Ingevuld kenteken is te lang</p>
                )}

                {fields.licensePlate?.replaceAll("-", "").length > 4 &&
                    fields.licensePlate?.replaceAll("-", "").length < 6 && (
                        <p>Ingevuld kenteken is te kort</p>
                    )}
            </div>

            <hr className="my-10 border-grey" />

            <h2 className="sm:text-2xl text-lg">Werkzaamheden</h2>
            <p className="sm:mb-10 mb-6">
                Selecteer de gewenste werkzaamheden voor uw werkplaatsafspraak
            </p>

            <div className="grid sm:grid-cols-4 grid-cols-2 gap-5">
                {options.map((option) => (
                    <Item
                        role="button"
                        key={option.title}
                        className={`sm:h-[165px] h-[135px] shadow-no-offset px-3 flex flex-col justify-center items-center text-white ring-primary hover:ring-4 ${
                            fields.options.includes(option.title)
                                ? "is-selected"
                                : ""
                        }`}
                        onClick={() => {
                            if (fields.options.includes(option.title)) {
                                fields.setOptions(
                                    fields.options.filter(
                                        (it) => it !== option.title
                                    )
                                )
                            } else {
                                fields.setOptions([
                                    ...fields.options,
                                    option.title,
                                ])
                            }
                        }}
                    >
                        {option.icon ? (
                            <img
                                className="w-[51px] h-[51px] mb-4"
                                src={option.icon.url}
                                alt=""
                            />
                        ) : (
                            <img
                                className="w-[51px] h-[51px] mb-4"
                                src={`${window.local_werkplaatsafspraak_object.asset}/tool.svg`}
                                alt=""
                            />
                        )}

                        <span
                            className="lg:text-lg sm:text-base text-sm font-bold text-center children-mb-0"
                            dangerouslySetInnerHTML={{ __html: option.title }}
                        />
                    </Item>
                ))}
            </div>

            {fields.licensePlate?.replaceAll("-", "").length === 6 &&
                fields.options.length > 0 && (
                    <div className="flex justify-end">
                        <button
                            onClick={() => fields.setStep(2)}
                            className="button primary mt-10 ml-auto"
                        >
                            Naar vestiging & datum
                        </button>
                    </div>
                )}
        </div>
    )
}
